import type { StorefrontAvailabilityGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierStorefrontAvailability = <
  TData = StorefrontAvailabilityGetResponseType,
>(
  supplierId: number,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      business?.id,
      ServerStateKeys.StorefrontAvailability,
      supplierId,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `suppliers/${supplierId}/storefront/availability`,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
  });
};
